import {getAbilityMod} from './get-ability-mod';

export function getSaveMod(ability: number, save?: string) {
	if (save) return save;
	return getAbilityMod(ability);
}
